import Vue, { CreateElement } from 'vue'

import { Component, Prop } from 'vue-property-decorator'

import { Icon } from '../icon/icon'

import './logo.sass'

@Component
export class Logo extends Vue {

  @Prop({ required: false, default: '' })
  type: 'gradient' | 'responsive' | ''

  render (h: CreateElement) {

    return <div class='logo'>

      {this.type === 'gradient' ? <Icon name={'logo/logo-gradient'} class='logo-gradient'/>

        : this.type === 'responsive' ? <div class='responsive'>
            <div class='thin'>
              <Icon name={'logo/logo-mark'} />
            </div>

            <div class='wide'>
              <Icon name={'logo/logo-type'} />
            </div>
          </div>

          : <Icon name={'logo/logo-type'} />}
    </div>
  }

}
